var PowerBiDashboardModule = (function () {
    function PowerBiDashboardModule() {
    }
    return PowerBiDashboardModule;
}());
export { PowerBiDashboardModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/power-bi-dashboard.module.ts.pre-build-optimizer.js